// JsFromRoutes CacheKey 12f1cb7f9d21fa8b28f6b16341cd3970
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('get', '/consumer/gift_tags/search'),
  popular: /* #__PURE__ */ definePathHelper('get', '/consumer/gift_tags/popular'),
  batch: /* #__PURE__ */ definePathHelper('get', '/consumer/gift_tags/batch'),
  canonicalVariants: /* #__PURE__ */ definePathHelper('get', '/consumer/gift_tags/canonical_variants'),
}
